/*
 * @Description: 版本路由
 * @Author: gao shuai
 * @Date: 2020-06-21 15:07:01
 * @LastEditTime: 2020-08-20 14:25:07
 * @LastEditors: gao shuai
 */
/*
export const url = process.env.NODE_ENV !== 'production' ? 'http://107.151.246.21:5003' : 'https://pa.leehong.net';
 */
export const url = 'VUE_APP_TENANT_URL';
